var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.75 16.25L11.25 11.75M2.25 8C2.25 8.68944 2.3858 9.37213 2.64963 10.0091C2.91347 10.646 3.30018 11.2248 3.78769 11.7123C4.2752 12.1998 4.85395 12.5865 5.49091 12.8504C6.12787 13.1142 6.81056 13.25 7.5 13.25C8.18944 13.25 8.87213 13.1142 9.50909 12.8504C10.146 12.5865 10.7248 12.1998 11.2123 11.7123C11.6998 11.2248 12.0865 10.646 12.3504 10.0091C12.6142 9.37213 12.75 8.68944 12.75 8C12.75 7.31056 12.6142 6.62787 12.3504 5.99091C12.0865 5.35395 11.6998 4.7752 11.2123 4.28769C10.7248 3.80018 10.146 3.41347 9.50909 3.14963C8.87213 2.8858 8.18944 2.75 7.5 2.75C6.81056 2.75 6.12787 2.8858 5.49091 3.14963C4.85395 3.41347 4.2752 3.80018 3.78769 4.28769C3.30018 4.7752 2.91347 5.35395 2.64963 5.99091C2.3858 6.62787 2.25 7.31056 2.25 8Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fd004b75f472074165f67ddc0b7d3f5d.svg";
export { ForwardRef as ReactComponent };